<div>
  <img src="../../../assets/zags.jpg">
  <p>
    If you just created an account, let Pat or Sol know, and they can get you set up!
  </p>
  <p>
    Otherwise, you might've tried to access a page you don't have access to.
  </p>
</div>
